import React,{useState,useEffect,useLayoutEffect} from 'react'
import { useSelector } from 'react-redux'
import {SliderSwitch,CarouselContainer,SlideProductContainer} from '../styles/Home'
import SliderContainer from '../components/Slider'
import SlideProducts from '../components/Slider/Products'
import SlideBrands from '../components/Slider/Brands'

import Header from '../components/Navigation/Header'
import BottomNav from '../components/Navigation/Bottom'
import Footer from '../components/Navigation/Footer'
import "react-activity/dist/Sentry.css";

import {useProductRequests} from '../helpers/ProductRequests'
import { useHistory } from 'react-router-dom'

import {Helmet} from "react-helmet";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { ProductContent } from '../styles/Content'
import ProductItem from '../components/Product/ProductCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { SwapButton } from '../styles/Product'
import Lightbox from 'react-spring-lightbox'
import { FloatingWhatsApp } from "react-floating-whatsapp";

export default function Home(props) {
  
  const {getProducts,getDiscover,getBrands,getSliders}=useProductRequests()
  
  const {slider}=useSelector(state=>state.site)
  const [sliders,setSliders]=useState('test1')
  const [images,setImages]=useState(null)

  const history=useHistory()

  const [discover,setDiscover]=useState([])
  const [man,setMan]=useState([])
  const [women, setWomen] = useState([]);
  const [garson, setGarson] = useState([]);
  const [filet, setFilet] = useState([]);
  const [bebe, setBebe] = useState([]);
  const [patik, setPatik] = useState([]);
  const [products,setProducts]=useState([])
  const [brands, setBrands] = useState([]);
  const [mainPageProducts, setMainPageProducts] = useState([]);
  const windowWidth=window.innerWidth
  const getHomePageCategoryItems = async () => {
    const list = [
      { slug: "erkek-40-44-1-1", set: setMan },
      { slug: "zenne-36-40-1-2", set: setWomen },
      { slug: "garson-36-39-1-3", set: setGarson },
      { slug: "filet-31-35-1-4", set: setFilet },
      { slug: "patik-26-30-1-270", set: setPatik },
      { slug: "bebe-21-25-1-6", set: setBebe },
    ];
    list.map(x=>{
      getProducts({ page: 1, count: windowWidth < 1786?windowWidth<1500?4:5:6, groupSlug: x.slug })
        .then((response) => {
          x.set(response.data.data.items);
        })
        .catch((error) => {});
    })
    getProducts({ page: 1, count:6, sort:'RANDOM',sortedBy:''})
      .then((response) => {
        setProducts(response.data.data.items);
      })
      .catch((error) => {});
    
  }
  useLayoutEffect(() => {
    
    if(discover.length===0){

      getProducts({ page: 1, count: 6,productOfDay: true })
        .then((response) => {
          setDiscover(response.data.data.items);

          getProducts({
            page: 1,
            count: 6,
            sort: "TOPSALES",
            productOfMainPage: true,
            sortedBy: "desc",
          }) 
            .then((response) => {
              setMainPageProducts(response.data.data.items);
            })
            .catch((error) => {
              //history.push('/giris-yap')
            });

              getHomePageCategoryItems();

          getBrands()
            .then((response) => {
              setBrands(response.data.data);
            })
            .catch((error) => {});
        })
        .catch((error) => {});

      

    }
  }, [])
 

  useEffect(() => {

    if (images == null || images.length == 0) {
      //REACT_APP_GET_SLIDERS
      getSliders().then((res) => {
        setImages(res.data.images);
      });
    }
  }, [sliders]);

  const [openedBox, setOpenedBox] = useState(false);
  const [currentImageIndex, setCurrentIndex] = useState(0);


  const gotoPrevious = () =>
    currentImageIndex > 0 && (setCurrentIndex(currentImageIndex - 1));

  const gotoNext = () =>
    currentImageIndex + 1 < products.map((x) => x.image).length &&
    (setCurrentIndex(currentImageIndex + 1));

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
        <title>
          Toptan Spor Ayakkabı Modelleri - Ulusoy Spor Ayakkabı , Ulusoy Toptan
          Ayakkabı
        </title>
      </Helmet>
      <FloatingWhatsApp phoneNumber="+905469000102" buttonStyle={{bottom:60,left:15}}  statusMessage='Her zaman aktif' accountName="Ulusoy Spor Ayakkabı" avatar="https://ulusoyspor.com.tr/favicon.ico"  placeholder='İletişime Geç!' chatMessage='Merhaba sitemize hos geldiniz. Size nasıl yardımcı olabiliriz?' />
      {/* <CookieConsent
        location="bottom"
        buttonText="Tümünü Kabul Et"
        cookieName="dehasoft"
        style={{
          background: "#DB2C1D",
          minHeight: "10vh",
          alignItems: "center",
        }}
        buttonStyle={{ color: "#000", fontSize: "15px" }}
        expires={250}
      >
        Bu web sitesi, kullanıcı deneyimini geliştirmek için tanımlama
        bilgilerini kullanır.{" "}
        <span style={{ fontSize: "10px" }}> &copy; dehasoft 2023</span>
      </CookieConsent> */}
      <Header />

      <div>
        {images != null && images.length > 0 ? (
          <CarouselContainer colors={slider}>
            <SliderSwitch>
              {/* <button onClick={()=>setSliders('test1')} className={sliders=='test1' ? 'active' : ''}>Afişlerimiz</button> */}
              {/* <button onClick={()=>setSliders('test2')} className={sliders=='test2' ? 'active' : ''}>Hepsi</button>  */}
              {/* <button onClick={()=>setSliders('test3')} className={sliders=='test3' ? 'active' : ''}>Hepsi</button>  */}
            </SliderSwitch>

            <SliderContainer images={images} products={discover} />
          </CarouselContainer>
        ) : (
          <></>
        )}
        <ProductContent open={false}>
          <div className="list">
            <div className="list-title-border">
              <h4>Erkek 40-44</h4>
            </div>
            {man.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Zenne 36-40</h4>
            </div>
            {women.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Garson 36-39</h4>
            </div>
            {garson.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Filet 31-35</h4>
            </div>
            {filet.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Patik 26-30</h4>
            </div>
            {patik.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Bebe 21-25</h4>
            </div>
            {bebe.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
            <div className="list-title-border">
              <h4>Keşfet</h4>
            </div>
            {products.map((x) => {
              return (
                <ProductItem
                  key={x.id + x.slug + "asda"}
                  product={x}
                  setOpenedBox={setOpenedBox}
                />
              );
            })}
          </div>
        </ProductContent>
      </div>
      <div style={{ zIndex: 1009090 }}>
        {products.length > 0 && (
          <Lightbox
            isOpen={openedBox}
            onPrev={gotoPrevious}
            className="lightbox-image-box"
            onNext={gotoNext}
            images={[...products,...man,...women,...garson,...filet,...patik,...bebe].map((x) => {
              return { src: x.image, loading: "lazy", alt: "deha" };
            })}
            currentIndex={currentImageIndex}
            onClose={() => setOpenedBox(false)}
            style={{ background: "#fff", zIndex: 1009090 }}
            renderNextButton={() => (
              <SwapButton onClick={gotoNext} className="image-swap-button">
                <FontAwesomeIcon icon={faAngleRight} />
              </SwapButton>
            )}
            renderPrevButton={() => (
              <SwapButton onClick={gotoPrevious} className="image-swap-button">
                <FontAwesomeIcon icon={faAngleLeft} />
              </SwapButton>
            )}
            renderFooter={() => (
              <div
                style={{
                  width: "40vw",
                  // background: "rgba(0,0,0,0.5)",
                  height: "40vh",
                  top: "30vh",
                  left: "30vw",
                  position: "fixed",
                  zIndex: 100,
                }}
                onClick={() => {
                  history.push(
                    "/urun/" +
                      [
                        ...products,
                        ...man,
                        ...women,
                        ...garson,
                        ...filet,
                        ...patik,
                        ...bebe,
                      ][currentImageIndex].slug
                  );
                }}
              ></div>
            )}
            renderHeader={() => (
              <button
                onClick={() => setOpenedBox(false)}
                className="light-close"
              >
                X
              </button>
            )}
            pageTransitionConfig={{
              from: { transform: "scale(0.75)", opacity: 0 },
              enter: { transform: "scale(1)", opacity: 1 },
              leave: { transform: "scale(0.75)", opacity: 0 },
              config: { mass: 1, tension: 320, friction: 32 },
            }}
          />
        )}
      </div>
      <BottomNav />

      <Footer />
    </>
  );
}
